
import { Vue, Component, Prop } from "vue-property-decorator";
import domtoimage from "dom-to-image";
import { pinyin } from "pinyin-pro";
import { Loading } from "element-ui";
import { formatUpyunUrl } from "@/utils";
import { dateToStr, numToStrM } from "@/utils/index";
@Component({
  components: {},
  filters: {
    getStatus(type: any): string {
      let txt = "";
      if (type == 0) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "學習中";
        } else {
          txt = "学习中";
        }
      } else if (type == 1) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "結業";
        } else {
          txt = "结业";
        }
      } else if (type == 2) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "畢業";
        } else {
          txt = "毕业";
        }
      }
      return txt;
    }
  }
})
export default class EMBAcompletion extends Vue {
  @Prop({ default: {} }) info!: any;
  dUser = require("@/assets/images/user.png");
  formatUpyunUrl = formatUpyunUrl;
  dateToStr = dateToStr;
  numToStrM = numToStrM;
  isDown = false;
  mounted() {
    let a = pinyin("張根本", { toneType: "none", type: "array" }).join(" ");
    // console.log(a.toUpperCase());
  }

  // 数字转中文数字
  number2Chinese(str: any) {
    let chinese = [
      "〇",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
      "十"
    ];
    let numStr = str.replace(/[^0-9]+/g, "");
    let year =
      chinese[numStr[0]] +
      chinese[numStr[1]] +
      chinese[numStr[2]] +
      chinese[numStr[3]];
    let month =
      numStr[4] === "0" ? chinese[numStr[5]] : chinese[10] + chinese[numStr[5]];
    let day = "";
    if (numStr[6] === "0") {
      day = chinese[numStr[7]];
    } else if (numStr[6] === "1") {
      if (numStr[7] === "0") {
        day = chinese[10];
      } else {
        day = chinese[10] + chinese[numStr[7]];
      }
    } else if (numStr[6] === "2" || numStr[6] === "3") {
      if (numStr[7] === "0") {
        day = chinese[numStr[6]] + chinese[10];
      } else {
        day = chinese[numStr[6]] + chinese[10] + chinese[numStr[7]];
      }
    }
    return year + "年" + month + "月" + day + "日";
  }

  // 生成证书
  save(index: number) {
    let load = Loading.service({
      lock: true,
      text: "生成图片中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.9)"
    });
    let node: any = null;
    let txt = "";
    if (index === 1) {
      node = document.getElementById("pm-certificate5");
      txt = "职业经理人EMBA学籍";
    } else if (index === 2) {
      node = document.getElementById("pm-certificate6");
      txt = "职业经理人EMBA毕业证书";
    } else if (index === 3) {
      node = document.getElementById("pm-certificate7");
      txt = "EMBA结业证书";
    }
    const scale = 2;
    const options = {
      width: node.clientWidth * scale,
      height: node.clientHeight * scale,
      style: {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left"
      }
    };
    const that = this;

    this.isDown = true;
    domtoimage.toPng(node, options).then(function(dataUrl: any) {
      let eleLink = document.createElement("a");
      eleLink.href = dataUrl; // 转换后的图片地址
      eleLink.download = txt;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
      that.isDown = false;
      load.close();
    });
  }
}
